module.exports = __webpack_public_path__ + "img/nyonyacooking.e742c9f4.svg";